// FIXME (jscheel && kevinrademan && jdarnok): As discussed, this file needs
// heavy refactoring so that it uses Immer for state changes. In the interest of
// time, we are not full refactoring for now (save for the tweaks in the PR that
// also added this note).

import { SEARCH_PAGE, TICKET_PAGE } from 'constants/pages'
import {
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_END,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_STARTED,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_CANCEL,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_HIDE,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_FAILED,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT_CLEAR,
  FETCH_AI_JOB_CONVERSATION_RESULT_STARTED,
  FETCH_AI_JOB_CONVERSATION_RESULT_END,
  FETCH_AI_JOB_CONVERSATION_RESULT_CLEAR,
  FETCH_AI_JOB_CONVERSATION_RESULT_INITIALIZE,
  FETCH_AI_JOB_CONVERSATION_RESULT_FAILED,
  FETCH_AI_JOB_COMPOSER_RESULT_STARTED,
  FETCH_AI_JOB_COMPOSER_RESULT_END,
  FETCH_AI_JOB_COMPOSER_RESULT_CLEAR,
  FETCH_AI_JOB_COMPOSER_RESULT_INITIALIZE,
  FETCH_AI_JOB_COMPOSER_RESULT_FAILED,
} from 'ducks/ai/types'

const instantReplyRequestInitialState = {
  response: null,
  loading: true,
  loaded: false,
  error: false,
  lastRequest: null,
  cancel: true,
  showPrompt: true,
}

const conversationRequestInitialState = {
  response: null,
  loading: false,
  loaded: false,
  error: false,
  lastRequest: null,
  rating: null,
  aiType: null,
  lastAiType: null,
}

const composerRequestInitialState = {
  response: null,
  loading: false,
  loaded: false,
  error: false,
  lastRequest: null,
  rating: null,
  aiType: null,
  lastAiType: null,
}

const initialState = {
  instantReplyRequest: { ...instantReplyRequestInitialState },
  conversationRequest: { ...conversationRequestInitialState },
  composerRequest: { ...composerRequestInitialState },
}

const reducers = {}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_STARTED] = state => {
  return {
    ...state,
    instantReplyRequest: {
      ...instantReplyRequestInitialState,
      loading: true,
    },
  }
}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_END] = (state, { payload }) => {
  const response = payload.result.result
  return {
    ...state,
    instantReplyRequest: {
      ...instantReplyRequestInitialState,
      response,
      loading: false,
      loaded: true,
      lastRequest: { ...payload.lastRequest }, // FIXME (jscheel): This will be better when immer is introduced
    },
  }
}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_CANCEL] = state => {
  return {
    ...state,
    instantReplyRequest: {
      ...instantReplyRequestInitialState,
      response: { title: '', body: '' },
      loading: false,
      cancel: true,
      loaded: true,
    },
  }
}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_HIDE] = state => {
  return {
    ...state,
    instantReplyRequest: {
      ...state.instantReplyRequest,
      showPrompt: false,
      loading: false,
      loaded: true,
    },
  }
}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_CLEAR] = state => {
  return {
    ...state,
    instantReplyRequest: {
      ...instantReplyRequestInitialState,
    },
  }
}

reducers[FETCH_AI_JOB_INSTANT_REPLY_RESULT_FAILED] = state => {
  return {
    ...state,
    instantReplyRequest: {
      ...state.instantReplyRequest,
      response: { title: '', body: '' },
      error: true,
      loading: false,
      loaded: true,
    },
  }
}

reducers[FETCH_AI_JOB_CONVERSATION_RESULT_STARTED] = state => {
  return {
    ...state,
    conversationRequest: {
      ...conversationRequestInitialState,
      loading: true,
      aiType: state.conversationRequest.aiType,
    },
  }
}

reducers[FETCH_AI_JOB_CONVERSATION_RESULT_END] = (state, { payload }) => {
  const response = payload.result.result
  return {
    ...state,
    conversationRequest: {
      ...conversationRequestInitialState,
      response,
      loading: false,
      loaded: true,
      lastAiType: state.conversationRequest.aiType,
      lastRequest: { ...payload.lastRequest }, // FIXME (jscheel): This will be better when immer is introduced
    },
  }
}

reducers[FETCH_AI_JOB_CONVERSATION_RESULT_CLEAR] = state => {
  return {
    ...state,
    conversationRequest: {
      ...conversationRequestInitialState,
    },
  }
}

reducers[FETCH_AI_JOB_CONVERSATION_RESULT_FAILED] = state => {
  return {
    ...state,
    conversationRequest: {
      ...conversationRequestInitialState,
      error: true,
      loading: false,
      loaded: true,
      aiType: state.conversationRequest.aiType,
    },
  }
}

reducers[FETCH_AI_JOB_CONVERSATION_RESULT_INITIALIZE] = (
  state,
  { payload }
) => {
  return {
    ...state,
    conversationRequest: {
      ...conversationRequestInitialState,
      loading: true,
      aiType: payload.aiType,
    },
  }
}

reducers[FETCH_AI_JOB_COMPOSER_RESULT_STARTED] = state => {
  return {
    ...state,
    composerRequest: {
      ...composerRequestInitialState,
      loading: true,
      aiType: state.composerRequest.aiType,
    },
  }
}

reducers[FETCH_AI_JOB_COMPOSER_RESULT_END] = (state, { payload }) => {
  const response = payload.result.result
  return {
    ...state,
    composerRequest: {
      ...composerRequestInitialState,
      response,
      loading: false,
      loaded: true,
      lastAiType: state.composerRequest.aiType,
      lastRequest: { ...payload.lastRequest }, // FIXME (jscheel): This will be better when immer is introduced
    },
  }
}

reducers[FETCH_AI_JOB_COMPOSER_RESULT_CLEAR] = state => {
  return {
    ...state,
    composerRequest: {
      ...composerRequestInitialState,
    },
  }
}

reducers[FETCH_AI_JOB_COMPOSER_RESULT_FAILED] = state => {
  return {
    ...state,
    composerRequest: {
      ...composerRequestInitialState,
      error: true,
      loading: false,
      loaded: true,
      aiType: state.composerRequest.aiType,
    },
  }
}

reducers[FETCH_AI_JOB_COMPOSER_RESULT_INITIALIZE] = (state, { payload }) => {
  return {
    ...state,
    composerRequest: {
      ...composerRequestInitialState,
      loading: true,
      aiType: payload.aiType,
    },
  }
}

// eslint-disable-next-line no-multi-assign
reducers[SEARCH_PAGE] = reducers[TICKET_PAGE] = state => {
  return {
    ...state,
    ...initialState,
  }
}

export default (state = initialState, action) => {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
